import {Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {ViewService} from '../../../shared/service/view.service';
import {Button} from 'primeng/button';
import {ActivatedRoute, NavigationEnd, Router, RouterLink} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {filter} from 'rxjs/operators';
import {RoutingHelper} from '../../../../helper/routing.helper';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-frontend-navigation',
    templateUrl: './frontend-navigation.component.html',
    styleUrls: ['./frontend-navigation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
  imports: [RouterLink, Button, TranslatePipe]
})
export class FrontendNavigationComponent implements OnInit, OnDestroy
{
  public view = inject(ViewService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  navigationItems: MenuItem[];
  @Input() set items(items: MenuItem[])
  {
    this.navigationItems = items;
    this.selectNavigationMenuItems();
  }
  @Input() subNavigation: boolean;
  @Input() showMobileLabels: boolean;
  @Input() autoSelect: boolean;

  @Output() onItemChanged = new EventEmitter<any>();

  navigationEndSubscription: Subscription;

  ngOnInit(): void
  {
    if (this.autoSelect)
    {
      this.navigationEndSubscription = this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() =>
      {
        const rt = RoutingHelper.getChild(this.activatedRoute);
        rt.data.subscribe(() => this.selectNavigationMenuItems());
      });
    }
  }

  ngOnDestroy(): void
  {
    this.navigationEndSubscription?.unsubscribe();
  }

  private selectNavigationMenuItems(): void
  {
    if (this.navigationItems && this.autoSelect)
    {
      // console.log('selectMenuItems()', this.navigationItems);
      const activeUrl = this.router.url;

      for (const menuItem of this.navigationItems)
      {
        const active = activeUrl.includes('/' + menuItem.url);
        // console.log('activeUrl: ' + activeUrl + ', active: ' + active + ', routerLink: ' + menuItem.url);
        menuItem.styleClass = active ? 'pushbutton-selected' : 'inactive';
        if (active)
          this.onItemChanged.emit(menuItem);
      }
    }
  }
}
